// dependencies
import { useState } from "react";

// components
import EducationCard from "./EducationCard";
import SimpleModal from "../../ui/Modal";

// image
import ait_logo from "../../../assets/imgs/education/ait_logo.png"
import ait_certificate from "../../../assets/imgs/education/ait_certificate.pdf"
import lewagon_logo from "../../../assets/imgs/education/lewagon_logo.png"
import lewagon_certificate from "../../../assets/imgs/education/lewagon_certificate.png"

// styles
import styles from "./css/EducationSection.module.css";


export default function EducationSection() {
    const [showModal, setShowModal] = useState(false);
    const [activeEducation, setActiveEducation] = useState(null);

    return (
        // background
        <div className={styles.educationSectionContainer}>
            {/* header, text, cards */}
            <div className={styles.contentContainer}>

                {/* header, text */}
                <div className={styles.textContainer}>
                    <div className={styles.headerText}>
                        Education & Certifications
                        <span className={styles.headerDivider}></span>
                    </div>
                    <div className={styles.aboutText}>
                        My academic journey and professional certifications that have shaped my knowledge and skills.
                    </div>
                </div>

                {/* cards */}
                <div className={styles.educationCardsContainer}>
                    <EducationCard 
                        imageSrc={ait_logo}
                        date={"2022 - 2025"}
                        header={"Bachelor of IT in Mobile Application Development"} 
                        text={"Academy of Interactive Technology (AIT)"} 
                        location={"Melbourne, VIC, Australia"}
                        isPrimary={true}
                        onClick={() => {setActiveEducation("ait"); setShowModal(true)}}
                    />
                    <EducationCard 
                        imageSrc={lewagon_logo}
                        date={"2020 - 2020"}
                        header={"Diploma of Full Stack Web Development"}
                        text={"LeWagon"} 
                        location={"Melbourne, VIC, Australia"}
                        isPrimary={false}
                        onClick={() => {setActiveEducation("lewagon"); setShowModal(true)}}
                    />
                </div>

                {/* modal */}
                { activeEducation === "lewagon" ? (
                    <SimpleModal show={showModal} onClose={() => setShowModal(false)}>
                        <img 
                            src={lewagon_certificate}
                            alt="Zoomed" 
                            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                        />
                    </SimpleModal>
                ) : (
                    <SimpleModal show={showModal} onClose={() => setShowModal(false)}>
                        <embed 
                            className={styles.pdfsAreAnnoying}
                            src={ait_certificate}
                            type="application/pdf"
                            zoom="100%"
                        />
                        <p className={styles.mobileFallback}>
                            <span>If the PDF doesn't display</span>
                            <a href={ait_certificate} target="_blank" rel="noreferrer">Click here to view it</a>
                        </p>
                    </SimpleModal>
                )}
            </div>
        </div>
    );
}
